import {
  BooleanDimension,
  NumbersEnumDimension,
  StringsDimension,
  StringsEnumDimension,
  TextDimension,
} from '@orus.eu/dimensions'
// Live in this leaf package: the floor's cross-product UI element types are structural, so nothing central imports these dimensions.
import { type RcphProduct, rcphProducts, rcphVersionValues } from '@orus.eu/product'

export const rcphProductLabels: { [product in RcphProduct]: string } = {
  TECH: "métiers de l'informatique",
  MAC: 'métiers du marketing et de la communication',
  MAN: 'métiers du conseil en entreprise',
  MEDIA: 'métiers des médias et de la culture',
  MISC: 'métiers du service',
  MISCBIE: 'métiers du bien-être',
  SECU: 'métiers de la sécurité',
  TAG: 'métiers du tourisme',
  ECOM: 'e-commerce',
}

export const rcphProductDimension = new StringsEnumDimension({
  name: 'rcphProduct',
  displayKeys: { name: 'dimension_name_rcph_product' },
  values: rcphProducts,
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const rcphProductLabelDimension = new TextDimension({
  name: 'rcphProductLabel',
  displayKeys: { name: 'dimension_name_rcph_product_label' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const rcphVersionDimension = new NumbersEnumDimension({
  name: 'rcphVersion',
  displayKeys: { name: 'dimension_name_rcph_version' },
  values: rcphVersionValues,
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
  valuesAreAmount: false,
} as const)

export { type RcphVersion } from '@orus.eu/product'

export const rcphHiscoxActivitiesNamesDimension = new StringsDimension({
  name: 'rcphHiscoxActivitiesNames',
  displayKeys: { name: 'dimension_name_rcph_hiscox_activities_names' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const rcphOptionCyberDimension = new BooleanDimension({
  name: 'rcphOptionCyber',
  displayKeys: { name: 'dimension_name_rcph_option_cyber' },
  considerForDifferenceComputationInUi: { client: true, partner: true, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const rcphOptionMrpSmallOfficeDimension = new BooleanDimension({
  name: 'rcphOptionMrpSmallOffice',
  displayKeys: { name: 'dimension_name_rcph_option_mrp_small_office' },
  considerForDifferenceComputationInUi: { client: true, partner: true, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const rcphOptionTdmiDimension = new BooleanDimension({
  name: 'rcphOptionTdmi',
  displayKeys: { name: 'dimension_name_rcph_option_tdmi' },
  considerForDifferenceComputationInUi: { client: true, partner: true, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
